module.exports = __webpack_public_path__ + "static/media/nicolai.57b60242.jpg";